module.exports = __webpack_public_path__ + "img/access-control-solutionimg-2.e13b8a78.png";